export default __webpack_public_path__ + "static/media/profast.bb2851f7.png";